import type { SelectionRule } from "./types";

export function summarizeRule(rule: SelectionRule | null | undefined, stages: { id: string; name: string }[]): string {
  if (!rule) return "—";
  const parts: string[] = [];
  if (rule.stage_ids?.length) {
    const names = rule.stage_ids.map((id) => stages.find((s) => s.id === id)?.name ?? "unknown stage");
    parts.push(`Stage: ${names.join(" / ")}`);
  }
  if (rule.title_keywords?.length) parts.push(`Title contains ${rule.title_keywords.map((k) => `'${k}'`).join(" or ")}`);
  if (rule.property_predicate) {
    const p = rule.property_predicate;
    const opText = { eq: "=", neq: "≠", contains: "contains", in: "in" }[p.op];
    const v = Array.isArray(p.value) ? p.value.join(", ") : p.value;
    parts.push(`${p.key} ${opText} ${v}`);
  }
  if (rule.ats_interview_kit_name) parts.push(`ATS kit: ${rule.ats_interview_kit_name}`);
  return parts.length ? parts.join(" and ") : "—";
}
